import { render, staticRenderFns } from "./DonutChart34.vue?vue&type=template&id=7afff093&scoped=true"
import script from "./DonutChart34.vue?vue&type=script&lang=js"
export * from "./DonutChart34.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afff093",
  null
  
)

export default component.exports